export const capitalizeFirstLetter = (string: string) => {
  if (string.length === 0) return string;
  if (string.length === 1) return string.toUpperCase();
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getInitials = (name?: string | null) => {
  const safe = (name ?? '').trim();
  if (!safe) return '';
  const parts = safe.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return safe.slice(0, 2).toUpperCase();
};
